import { render, staticRenderFns } from "./LogStatistics.vue?vue&type=template&id=a22a6ac0&scoped=true&"
import script from "./LogStatistics.vue?vue&type=script&lang=js&"
export * from "./LogStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22a6ac0",
  null
  
)

export default component.exports